// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import  baseScoreContainerView  from '../../../../../templates/MIPS/AdvancingCare/Summary/baseScoreContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    className: 'col s6 pln',

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
        this.listenTo( this.model, 'change:summaryData', this.render )
    },

    getTemplate: function() {
        return baseScoreContainerView( this.model );
    },

});
